module.exports = __webpack_public_path__ + "static/media/50-off-campaign-title-image.528c984d.png";